import * as React from 'react';

import './category-pill.scss';

type Props = {
  label: string,
  searchQuery?: string,
  clickable?: boolean
};

class CategoryPill extends React.PureComponent<Props> {
  render() {
    const { label, searchQuery, clickable } = this.props;

    if (!label) {
      return null;
    }

    if (!clickable || !searchQuery) {
      return (
        <span className="category-pill">
          {label}
        </span>
      );
    }

    return (
      <a
        href={`/content-creator/profiles?${searchQuery}`}
        className="category-pill category-pill--clickable"
        rel="noopener noreferrer"
        target="_blank"
      >
        {label}
      </a>
    );
  }
}

export default CategoryPill;
